import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Verify } from "../store/users";
import { useNavigate, useParams } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";

const VerifyComponent = (props) => {
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { country } = useParams();
  const { t } = useI18n();

  const handleSend = async () => {
    try {
      // Dispatch the verification action and wait for it to complete
      await dispatch(Verify({ code: code }));

      // Only navigate if verification was successful
      navigate(`/${country}`);
    } catch (error) {
      // Handle verification failure (show error message, etc.)
      navigate(`/${country}`);
      console.error("Verification failed:", error);
    }
  };
  return (
    <div className="container w-full h-screen">
      <div className="flex justify-center my-24 ">
        <div>
          <p className="text-lg py-3">{t("verify.prompt")}</p>
          <div className="flex flex-row justify-between">
            <input
              className="bg-slate-100 py-2 number-input w-20"
              name="code"
              type="number"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />
            <button
              className="bg-lime-300 text-black hover:bg-lime-500 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mx-2"
              onClick={handleSend}
            >
              {t("verify.button")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyComponent;
